import script from "./cashbackWeekDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./cashbackWeekDetails.vue?vue&type=script&lang=ts&setup=true"

import "./cashbackWeekDetails.vue?vue&type=style&index=0&id=63c7bc7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c7bc7c"]])

export default __exports__